export default __webpack_public_path__ + "static/media/6.6b2b02c6.webp";